module.exports = __webpack_public_path__ + "img/school_bg.9317f9db.jpg";